'use strict';

var angular = require('angular');
var GridToolbarRuleListingDirective = function GridToolbarRuleListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-rule-listing.html'),
    controller: 'GridToolbarRuleListingController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', scope.onRowSelection);
      scope.deleteRules = function () {
        angular.element('#delete-rule-modal').modal('show');
      };
    }
  };
};
GridToolbarRuleListingDirective.$inject = [];
module.exports = GridToolbarRuleListingDirective;